import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import schoolLogo from '../../assets/images/logos/schoolLogo.png';  // ✅ Your logo
import saraswati from '../../assets/images/logos/saraswati.jpeg';  // ✅ Your logo
// import studentPhoto from '../../assets/images/users/student.jpg'; // ✅ Sample student image
import signPhoto from '../../assets/images/logos/p_sign.jpeg'; // ✅ Sample student image
import { formatDate } from '../../constants/DateFormatter';
import { green } from 'material-ui-core/colors';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 5,
  },
  card: {
    width: 153, // 5.4 cm
    height: 240, // 8.5 cm
    border: '1px solid black',
    borderRadius: 5,
    marginTop: 15,
    marginBottom: 15,
    marginLeft: 5,
    marginRight: 5,
    padding: 5,
    fontSize: 8,
    position: 'relative',
  },
  header: { textAlign: 'center', marginBottom: 2 },
  logo: { width: 25, height: 25, position: 'absolute', top: 20, left: 5 },
  deityImage: { width: 25, height: 25, position: 'absolute', top: 20, right: 5 },
  signImage: { width: 50, height: 25, position: 'absolute', bottom: 15, right: 5 },
  centerText: { fontSize: 10, fontWeight: 'bold', color: 'green', marginBottom: 2, textAlign: "center" },
  subText: { fontSize: 8, fontWeight: 'bold' },
  bold: { fontWeight: 'bold' },
  footer: {
    position: 'absolute',
    bottom: 5,
    left: 5,
    right: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
  }
});

const labelStyle = { width: 40, fontWeight: 'bold' }; // fixed width label
const valueStyle = { flex: 1 };

const StudentCard = ({ systemData, student, sessionYear }) => (
  <View style={styles.card}>
    <Text style={styles.centerText}>{systemData.school_name}</Text>

    <Image style={styles.logo} src={schoolLogo} />
    <Image style={styles.deityImage} src={saraswati} />

    <View style={styles.header}>
      <Text style={{ fontSize: 6 }}>(Recognised)</Text>
      <Text style={{ fontSize: 6, color: 'blue', marginTop: 2 }}>SCHOOL ID. {systemData.school_code}</Text>
      <Text style={{ fontSize: 6, marginTop: 2, borderColor: "green", borderRadius: 5 }}>{systemData.address}</Text>
      <Text style={{ fontSize: 6 }}>{systemData.school_phn}</Text>
    </View>


    <View style={{ flexDirection: 'row', alignItems: 'flex-start', gap: 10 }}>
      <View style={{ marginTop: 15, alignItems: "center" }}>
        <Text>Adm. No.:</Text>
        <Text>{student?.admission?.admit_no}</Text>
      </View>

      {/* <Image
        style={{ width: 45, height: 45, marginLeft: 10 }}
        src={{ uri: process.env.REACT_APP_API_BASE_URL + student?.admission?.stud_img_path, method: "GET", headers: { "Cache-Control": "no-cache" }, body: "" }} 
      /> */}
      
      <Image style={{ width: 45, height: 45, marginLeft: 10 }} src={student.base64Image}     />
      <View style={{ marginTop: 15, alignItems: "center" }}>
        <Text>Class:</Text>
        <Text>{student?.course_name}</Text>
      </View>

    </View>

    <Text style={{ marginBottom: 3, marginTop: 3, color: "white", backgroundColor: "green", textAlign: "center", padding: 3, borderRadius: 5, fontSize: 10 }}>{student?.admission?.stud_name}</Text>


    <View>
      <View style={{ flexDirection: 'row', marginBottom: 2 }}>
        <Text style={labelStyle}>D.O.B.</Text>
        <Text style={valueStyle}>: {formatDate(student?.admission?.d_o_b)}</Text>
      </View>

      <View style={{ flexDirection: 'row', marginBottom: 2 }}>
        <Text style={labelStyle}>F's/Name</Text>
        <Text style={valueStyle}>: {student?.admission?.f_name}</Text>
      </View>

      <View style={{ flexDirection: 'row', marginBottom: 2 }}>
        <Text style={labelStyle}>M's/Name</Text>
        <Text style={valueStyle}>: {student?.admission?.m_name}</Text>
      </View>

      <View style={{ flexDirection: 'row', marginBottom: 2 }}>
        <Text style={labelStyle}>Address</Text>
        <Text style={valueStyle}>
          : {student?.admission?.sadd1}, {student?.admission?.sadd2}, {student?.admission?.sadd3}
        </Text>
      </View>

      <View style={{ flexDirection: 'row', marginBottom: 3 }}>
        <Text style={{ minWidth: 40, fontWeight: 'bold' }}>Contact No.</Text>
        <View style={valueStyle}>
          <Text>: {student?.admission?.f_mob}</Text>
          <Text style={{ marginLeft: 2 }}>  {student?.admission?.m_mob}</Text>
        </View>
      </View>
    </View>


    <Image style={styles.signImage} src={signPhoto} />
    <View style={styles.footer}>
      <Text style={{ fontSize: 7, backgroundColor: "blue", color: "white", padding: 2 }}>I-Card : {sessionYear}</Text>
      <Text style={{ fontSize: 7 }}>Principal's Sign.</Text>
    </View>
  </View>
);

const IDCardPdf = ({ students, systemData, sessionYear }) => {

  
  // Helper function to chunk the array
  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const getBase64FromUrl = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

// const prepareStudents = async (students) => {
//   return await Promise.all(
//     students.map(async (student) => {
//       const url = `https://schoolapi.shivkms.com/${student?.admission?.stud_img_path}`;

//       let base64Image = "";
//       try {
//         base64Image = await getBase64FromUrl(url);
//       } catch {}

//       return {
//         ...student,
//         base64Image,
//       };
//     })
//   );
// };

  // In your component
  const studentChunks = chunkArray(students, 10);

  return (
    <Document>
      {studentChunks.map((group, pageIndex) => (
        <Page orientation="landscape" size="A4" style={styles.page}>
          {group.map((student, idx) => (
            <StudentCard key={idx} student={student} systemData={systemData} sessionYear={sessionYear} />
          ))}
        </Page>
      ))}
      {/* <Page size="A4" style={styles.page}>
      {students.map((student, idx) => (
        <StudentCard key={idx} student={student} />
      ))}
    </Page> */}
    </Document>
  );
}

export default IDCardPdf;
